
import { AWSFile } from "@/models/aws-file";
import { Project } from "@/models/base";
import { ProjectAwsDocument } from "@/models/base/project-aws-document";
import Vue from "vue";
import AppAwsFilesInfo from "@/components/aws-files-modules/AwsFilesInfo.vue";

export default Vue.extend({
	data(){
		return {
			showPreview: false,
			previewFile: {} as AWSFile
		};
	},
	props: {
		project: {
			type: Object as ()=>Project,
			required: true
		}
	},
	computed: {
		items():ProjectAwsDocument[] {
			return this.project.AWSDocuments.filter(f=>f.File != null);
		},
	},
	components: {
		AppAwsFilesInfo
	}
});
